export const openDrawer = (id: string) => {
    const openEvent = new CustomEvent(`ovasai:drawer:open:${id}`);
    document.dispatchEvent(openEvent);
}
